module.exports = __webpack_public_path__ + "static/tickethoss-default-logo-c692f91f0ed1d8fe01281e065c44c141.png";